// sendLink.tsx (no change required, it already refreshes values via getCustomerDetail)
import React, { useEffect, useState } from "react";
import { Box, Grid, TextField } from "@mui/material";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerDetail } from "redux/actions/customerMaster";

interface SendLinkProps {
  customerId: number;
}

const SendLink: React.FC<SendLinkProps> = ({ customerId }) => {
  const dispatch = useDispatch();
  const customer = useSelector((state: any) => state.customerMaster.currentCustomer);

  const [formValues, setFormValues] = useState({
    customer_care_id: "",
    feasibility: "",
    lat_long: "",
    map_address: "",
  });

  const validationSchema = Yup.object({
    customer_care_id: Yup.string().required("Lead ID is required"),
    feasibility: Yup.string().required("Feasibility is required"),
    lat_long: Yup.string().required("Lat Long is required"),
    map_address: Yup.string().required("Map Address is required"),
  });

  useEffect(() => {
    dispatch<any>(getCustomerDetail(customerId));
  }, [customerId, dispatch]);

  useEffect(() => {
    if (customer) {
      setFormValues({
        customer_care_id: customer.customer_care_id || "",
        feasibility: customer.feasibility || "",
        lat_long: customer.latLong || "",
        map_address: customer.map_address || "",
      });
    }
  }, [customer]);

  return (
    <Box>
      <Grid>
        <Formik
          initialValues={formValues}
          validationSchema={validationSchema}
          enableReinitialize
          onSubmit={() => {}}
        >
          {({ touched, errors }) => (
            <Form>
              <Grid container spacing={3} mb={3}>
                <Grid item xs={12} md={4}>
                  <Field
                    as={TextField}
                    fullWidth
                    disabled
                    label="Customer ID"
                    name="customer_care_id"
                    error={touched.customer_care_id && !!errors.customer_care_id}
                    helperText={<ErrorMessage name="customer_care_id" />}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <Field
                    as={TextField}
                    fullWidth
                    disabled
                    label="Feasibility"
                    name="feasibility"
                    error={touched.feasibility && !!errors.feasibility}
                    helperText={<ErrorMessage name="feasibility" />}
                  />
                </Grid>

                <Grid item xs={12} md={4}>
                  <Field
                    as={TextField}
                    fullWidth
                    disabled
                    label="Lat Long"
                    name="lat_long"
                    error={touched.lat_long && !!errors.lat_long}
                    helperText={<ErrorMessage name="lat_long" />}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3} mb={3}>
                <Grid item xs={12}>
                  <Field
                    as={TextField}
                    fullWidth
                    disabled
                    multiline
                    minRows={2}
                    label="Map Address"
                    name="map_address"
                    error={touched.map_address && !!errors.map_address}
                    helperText={<ErrorMessage name="map_address" />}
                  />
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </Grid>
    </Box>
  );
};

export default SendLink;
